module.exports = "/_next/static/images/cccbc0c2d10fd2688b9bffe7b1d38100-pay-yourself-md@1x.jpg.webp";